import {
  SignupVerificationRequest,
  SignupVerificationResponse,
  SignupVerificationResultRequest,
  SignupVerificationResultResponse,
} from "../types/signup";
import { apiClient } from "./api";

export const signupService = {
  /**
   * 유저 회원가입 본인인증 URL 요청
   */
  async requestSignupVerification(
    request: SignupVerificationRequest
  ): Promise<SignupVerificationResponse> {
    const response = await apiClient.post<SignupVerificationResponse>(
      "/users/signup/request",
      request
    );
    return response.data;
  },

  /**
   * 본인인증 결과 처리
   */
  async processSignupVerificationResult(
    request: SignupVerificationResultRequest
  ): Promise<SignupVerificationResultResponse> {
    const response = await apiClient.post<SignupVerificationResultResponse>(
      "/users/signup/response",
      request
    );
    return response.data;
  },
};
